import PTZIcon from "../../assets/product-list-assets/ptz.svg";
import type { ProductListGroup } from "../../types";

export const ptz: ProductListGroup = {
  id: "ptz",
  title: "productListGroup.ptz.title",
  icon: {
    src: PTZIcon,
    width: 16,
    height: 21,
  },
};
